import { BrowserModule } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { RetrieveUsernameComponent } from './retrieve-username/retrieve-username.component';
import {
  VueAppDefaultsService,
  VueModule
} from '@vue/vueframework';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { MatRadioModule } from '@angular/material/radio';
import { FormsModule } from '@angular/forms';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { AppDefaultsService } from './app-default.service';
import { DisplayUsernameComponent } from './display-username/display-username.component';
import { RetrieveUserComponent } from './retrieve-user/retrieve-user.component';
import { RetrievePasswordComponent } from './retrieve-password/retrieve-password.component';
import { PasswordResetOptionsComponent } from './password-reset-options/password-reset-options.component';
import { AccountRecoveryUtil } from './shared/utils/accountrecovery.utils';
import { PasswordResetUpdateComponent } from './password-reset-update/password-reset-update.component';
import { WebngRedirectFormComponent } from './webng-redirect-form/webng-redirect-form.component';
import { AppConfigService } from './shared/services/app-config.service';
import { AppConfig } from './shared/types/app-config.type';

@NgModule({ bootstrap: [ AppComponent ],
  declarations: [
    AppComponent,
    RetrieveUsernameComponent,
    PageNotFoundComponent,
    DisplayUsernameComponent,
    RetrieveUserComponent,
    RetrievePasswordComponent,
    PasswordResetOptionsComponent,
    PasswordResetUpdateComponent,
    WebngRedirectFormComponent
  ], imports: [ BrowserModule,
    AppRoutingModule,
    FormsModule,
    MatRadioModule,
    VueModule.forRoot() ], providers: [
    AppConfigService,
    { deps: [ AppConfigService ], multi: true, provide: APP_INITIALIZER, useFactory: appConfigInitializerFn },
    {
      provide: VueAppDefaultsService,
      useClass: AppDefaultsService
    },
    AccountRecoveryUtil,
    provideHttpClient(withInterceptorsFromDi())
  ] })
export class AppModule { }

/**
 * Factory function that is called when initializing the app.<br />
 * Will fetch the environment specific configuration
 *
 * @param appConfig service used to get environment-specific configuration.
 * @returns a promise.
 */

export function appConfigInitializerFn(appConfig: AppConfigService) {
  return (): Promise<AppConfig> => {
    return appConfig.loadAppConfig();
  };
}
